
export enum DirectSaleComputedState {
  NoActiveOrder= 'NoActiveOrder',
  PendingPayment= 'PendingPayment',
  Sold= 'Sold',
  CloseUnsold= 'CloseUnsold',
  UnderNegotiation= 'UnderNegotiation',

}